import { z } from 'zod';

export const npsCampaignFormSchema = z
  .object({
    name: z.string().min(1, 'Nome é obrigatório'),
    companyId: z.coerce.number().min(1, 'Empresa é obrigatória'),
    startAt: z.string().min(1, 'Início é obrigatório'),
    endAt: z.string().min(1, 'Fim é obrigatório'),
    metricsVisibleToCompany: z.boolean(),
    commentsVisibleToCompany: z.boolean(),
    exportAvailableToCompany: z.boolean(),
  })
  .refine((data) => new Date(data.endAt) > new Date(data.startAt), {
    message: 'Fim deve ser posterior ao início',
    path: ['endAt'],
  });

export type NpsCampaignFormSchema = z.infer<typeof npsCampaignFormSchema>;
